import { connectionTypeDefinitions } from './ConnectionTypeDefinitions';
class LiveStreamRegistry {
    constructor() {
        this.streams = new Map();
        this.listeners = new Set();
        this.registerKnownStreams();
    }
    registerStream(stream) {
        var _a, _b;
        const existing = this.streams.get(stream.name);
        const next = Object.assign(Object.assign({}, stream), { isConnected: (_b = (_a = stream.isConnected) !== null && _a !== void 0 ? _a : existing === null || existing === void 0 ? void 0 : existing.isConnected) !== null && _b !== void 0 ? _b : false });
        const changed = !existing ||
            existing.label !== next.label ||
            existing.url !== next.url ||
            existing.canSend !== next.canSend ||
            existing.isConnected !== next.isConnected;
        this.streams.set(stream.name, next);
        if (changed) {
            this.emit();
        }
    }
    setConnectionState(name, isConnected) {
        const existing = this.streams.get(name);
        if (!existing) {
            return;
        }
        if (existing.isConnected === isConnected) {
            return;
        }
        this.streams.set(name, Object.assign(Object.assign({}, existing), { isConnected }));
        this.emit();
    }
    getSnapshot() {
        return Array.from(this.streams.values());
    }
    subscribe(listener) {
        this.listeners.add(listener);
        listener(this.getSnapshot());
        return () => {
            this.listeners.delete(listener);
        };
    }
    emit() {
        const snapshot = this.getSnapshot();
        this.listeners.forEach((listener) => listener(snapshot));
    }
    registerKnownStreams() {
        connectionTypeDefinitions.forEach((definition) => {
            this.registerStream({
                name: definition.name,
                label: definition.label,
                url: definition.streamUrl,
                canSend: definition.canSend,
                isConnected: false,
            });
        });
    }
}
function resolveRegistry() {
    const globalScope = globalThis;
    if (!globalScope.__liveStreamRegistry) {
        globalScope.__liveStreamRegistry = new LiveStreamRegistry();
    }
    return globalScope.__liveStreamRegistry;
}
export const liveStreamRegistry = resolveRegistry();
